import React from 'react'
import {buldingiconpng} from '../../assets/ImageExports'

const CompanyManagement = () => {
  return (
    <div>
      <div className="container py-4">
    <div className="mb-4 d-flex ">
        <div style={{ width: 100, height: 100, backgroundColor: '#e9ecef', 
         display:'flex', justifyContent:"center", alignItems:'center',    
        borderRadius: 8 }}>
     <img src={buldingiconpng}/> 
        </div>
        <div style={{marginLeft:"20px"}}> 
         <h5 className="mt-3 mb-1">Apptimate PVT.LTD</h5>
         <p className="text-muted">IT Industry</p>
         </div>
      </div>

      <form>
        <div className="mb-3">
          <label className="form-label">Street Address</label>
          <input
            type="text"
            className="form-control rounded-pill"
            defaultValue="Esplanade One, Puri-Cuttack Road, Rasulgarh Industrial Estate"
          />
        </div>

        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">City</label>
            <input type="text" className="form-control rounded-pill" defaultValue="Rasulgarh" />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">District</label>
            <input type="text" className="form-control rounded-pill" defaultValue="Bhubaneswar" />
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">Country</label>
            <input type="text" className="form-control rounded-pill" defaultValue="Rasulgarh" />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">State</label>
            <input type="text" className="form-control rounded-pill" defaultValue="Rasulgarh" />
          </div>
        </div>

        <div className="mb-3">
          <label className="form-label">Pincode</label>
          <input type="text" className="form-control rounded-pill" defaultValue="70413" />
        </div>
      </form>
    </div>
    </div>
  )
}

export default CompanyManagement; 
